module.exports = __webpack_public_path__ + "static/media/usb-drive.72753643.svg";